import Clickable from "@insite/mobius/Clickable";
import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import Stack from "@midland-industries/Components/Stack";
import { colors } from "@midland-industries/Styles/colors";
import React from "react";
import { css } from "styled-components";

interface BrowseMenuProps {
    isOpen?: boolean;
    onClose: any;
}

const itemCss = css`
    width: 100%;
    padding: 6px 15px;
    &:hover {
        background: ${colors.accent};
        border-radius: 10px;
    }
`;

const linkCss = css`
    color: ${colors.textLink} !important;
`;

const BrowseMenu: React.FC<BrowseMenuProps> = ({ isOpen, onClose }) => {
    return (
        <div style={{ display: isOpen ? "block" : "none", paddingTop: 5, position: "absolute", marginLeft: "-15px" }}>
            <div
                style={{
                    padding: 15,
                    borderRadius: "10px",
                    background: "#FFFFFF",
                    boxShadow: "0px 3px 10px 0px rgba(122, 122, 125, 0.15)",
                }}
                onMouseLeave={onClose}
            >
                <Group gap={15}>
                    <Stack style={{ width: 333 }}>
                        <Group justify="space-between" style={{ paddingLeft: 15, marginBottom: 12 }}>
                            <Typography transform="uppercase" color={colors.textAccent}>
                                popular categories
                            </Typography>
                            <Clickable href="/Categories" onClick={onClose} css={linkCss}>
                                View all categories
                            </Clickable>
                        </Group>
                        <Clickable href="/catalog/Hose-Fittings" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Hose Fittings
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/MAF-USA-Brass-Fittings" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                MFA/USA Brass Fittings
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Brass-Fittings" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Brass Fittings
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Lead-Free-Fittings" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Lead Free Fittings
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Valves" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Valves
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Nipples-and-Fittings" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Nipples and Fittings
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Plastic-Fittings" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Plastic Fittings
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Clamps" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Clamps
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Tubing" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Tubing
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Pneumatics" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Pneumatics
                            </Typography>
                        </Clickable>
                        <Clickable href="/catalog/Hydraulics" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Hydraulics
                            </Typography>
                        </Clickable>
                    </Stack>
                    <div style={{ width: "1px", background: colors.border }} />
                    <Stack style={{ width: 333 }}>
                        <Typography
                            transform="uppercase"
                            color={colors.textAccent}
                            style={{ paddingLeft: 15, marginBottom: 12 }}
                        >
                            markets we serve
                        </Typography>
                        <Clickable href="/Markets/Industrial" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Industrial
                            </Typography>
                        </Clickable>
                        <Clickable href="/Markets/Plumbing" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Plumbing
                            </Typography>
                        </Clickable>
                        <Clickable href="/Markets/Waterworks" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Waterworks
                            </Typography>
                        </Clickable>
                        <Clickable href="/Markets/Marine" onClick={onClose}>
                            <Typography color={colors.textAccent} size={15} lineHeight="24px" css={itemCss}>
                                Marine
                            </Typography>
                        </Clickable>
                    </Stack>
                </Group>
            </div>
        </div>
    );
};

export default BrowseMenu;
